// Who is typing, as a THREAD pane says it (ios/Sources/Views/TypingIndicatorView.swift resolveNames):
// a thread is a subsection of the chat, not a separate room (user, 2026-10-07: "inside the thread show
// the typing like outside the thread"), so the parent conversation's typists show too — said "en el
// chat" because their message will not land in this pane. Someone typing in BOTH scopes is said once,
// where they are typing into this pane. Thread typists win (TypingIndicatorLabel).
import type { TypingTracker } from './typingTracker';
import { TypingIndicatorLabel } from './typingIndicatorLabel';

export interface ThreadTypists {
  here: string[];
  inChat: string[];
}

export function typists(tracker: TypingTracker, channelId: string, rootId: string, now: number): ThreadTypists {
  if (!channelId || !rootId) return { here: [], inChat: [] };
  const here = tracker.typistIds(channelId, rootId, now);
  const inChat = tracker.typistIds(channelId, '', now).filter((id) => !here.includes(id));
  return { here, inChat };
}

/** The slot's text: names resolved by the caller (FULL names, sorted, like the Apple view). */
export function label(t: ThreadTypists, nameOf: (userId: string) => string): string | null {
  const names = (ids: string[]) => ids.map(nameOf).sort();
  return TypingIndicatorLabel.text(names(t.here), names(t.inChat));
}

export const ThreadTyping = { typists, label } as const;
